import React from 'react';

import { canStartTrial, UpgradeAccount } from '@paragon/login-tools';
import { Dialog } from '@paragon/popup-state';
import { createScrollbarStyling } from '@paragon/themes';

import { useAppSelector } from '../hooks';

export function UpgradeAccountDialog(props: { readonly message?: string; readonly onClose?: () => void }) {
  const usageData = useAppSelector((state) => state.usageData);
  const trialAvailable = useAppSelector(canStartTrial);

  return (
    <Dialog
      title={trialAvailable ? 'Start your free trial' : 'Upgrade your account'}
      variant="design"
      actionsNode={null}
      contentSx={createScrollbarStyling}
      onClose={props.onClose}
    >
      <UpgradeAccount
        message={
          props.message ??
          (usageData && usageData.quotaPerMonth !== null
            ? `You have used ${usageData.usageThisMonth} of ${usageData.quotaPerMonth} truss designs for this month.`
            : undefined)
        }
        successUrl={window.location.href}
        cancelUrl={window.location.href}
      />
    </Dialog>
  );
}
